// ABOUTME: Components + granularity list used by the CREATED_AT grouping preset.
// ABOUTME: The registry entry that references these lives in groupingPresets/index.js.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

import { tokens } from "../../../../theme";
import Text from "../../text/Text";
import { GRANULARITY_KEYS } from "../groupingDateGranularities";

export const CREATED_AT_GRANULARITIES = [
    GRANULARITY_KEYS.MIN_15,
    GRANULARITY_KEYS.HOUR,
    GRANULARITY_KEYS.HOUR_4,
    GRANULARITY_KEYS.DAY,
    GRANULARITY_KEYS.WEEK,
    GRANULARITY_KEYS.MONTH,
];

export const CreatedAtLabel = ({ groupKey }) => {
    const { i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const date = new Date(groupKey);
    return (
        <Box sx={{
            display: "inline-flex", alignItems: "center", gap: 1, height: 32, px: 1.5,
            borderRadius: 4,
            background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
            color: colors.txt.primary,
        }}>
            <CalendarTodayOutlinedIcon fontSize="small" sx={{ color: colors.txt.secondary, fontSize: 16 }} />
            <Text>
                <b>{date.toLocaleDateString(i18n.language, { dateStyle: "short" })}</b>
                {"  "}
                <Text light>{date.toLocaleTimeString(i18n.language, { timeStyle: "short" })}</Text>
            </Text>
        </Box>
    );
};

export const CreatedAtPreview = () => {
    const { i18n } = useTranslation();
    return <Text>{new Date().toLocaleDateString(i18n.language, { dateStyle: "short" })}</Text>;
};
